<template>
  <SystemSetting />
</template>

<script>
import SystemSetting from "@/views/Settings/SystemSettings/SystemSetting";
import {mapState} from "vuex";
export default {
  name: "SystemSettings",

  components: {
    SystemSetting
  },

  computed: {
    ...mapState({
      apiLanguage: state => state.Language.apiLanguage
    })
  },

  created() {
    this.$store.commit("Option/ApiOptions/setLang", this.apiLanguage);
  }
};
</script>

<style></style>